import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "row ms-4 me-4 mt-0 mb-0" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-12" }
const _hoisted_5 = { class: "card card-body mb-0" }
const _hoisted_6 = { class: "row mb-2" }
const _hoisted_7 = { class: "form-group col-sm-12" }
const _hoisted_8 = { class: "navbar-nav overflow-auto flex-row gap-4" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "row mb-2 align-items-end" }
const _hoisted_11 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_14 = { class: "form-group col" }
const _hoisted_15 = { class: "col-auto p-0 text-end" }
const _hoisted_16 = { class: "row m-4 mt-0" }
const _hoisted_17 = { class: "col-sm-12" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-sm-12" }
const _hoisted_20 = { class: "card card-body" }
const _hoisted_21 = { class: "" }
const _hoisted_22 = { class: "d-flex justify-content-end align-items-end mb-2 me-2" }
const _hoisted_23 = { class: "overflow-auto" }
const _hoisted_24 = { class: "table table-striped border-light align-middle text-left text-nowrap position-relative" }
const _hoisted_25 = { style: {"width":"0"} }
const _hoisted_26 = { style: {"width":"0"} }
const _hoisted_27 = {
  key: 0,
  class: "d-flex flex-column"
}
const _hoisted_28 = ["title"]
const _hoisted_29 = ["disabled", "onClick", "checked"]
const _hoisted_30 = ["title"]
const _hoisted_31 = ["disabled", "onClick", "checked"]
const _hoisted_32 = { style: {"width":"0"} }
const _hoisted_33 = { style: {"width":"0"} }
const _hoisted_34 = { class: "badge bg-dark" }
const _hoisted_35 = ["title"]
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "col-sm-12 d-flex align-items-center justify-content-between" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { class: "subtext" }
const _hoisted_41 = { style: {"max-width":"300px","white-space":"normal"} }
const _hoisted_42 = {
  key: 0,
  class: "badge bg-primary me-1"
}
const _hoisted_43 = {
  key: 1,
  class: "badge bg-primary me-1"
}
const _hoisted_44 = {
  key: 2,
  class: "badge bg-primary me-1"
}
const _hoisted_45 = { class: "badge bg-primary me-1" }
const _hoisted_46 = {
  key: 3,
  class: "badge bg-primary me-1"
}
const _hoisted_47 = { style: {"padding":"0"} }
const _hoisted_48 = {
  key: 0,
  style: {"width":"200px","height":"70px"}
}
const _hoisted_49 = { class: "text-end" }
const _hoisted_50 = {
  key: 0,
  class: "btn-group"
}
const _hoisted_51 = ["onClick"]
const _hoisted_52 = {
  type: "button",
  class: "btn btn-sm btn-outline-dark dropdown-toggle dropdown-toggle-split",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_53 = { class: "dropdown-menu" }
const _hoisted_54 = { key: 0 }
const _hoisted_55 = ["onClick"]
const _hoisted_56 = ["onClick"]
const _hoisted_57 = { key: 1 }
const _hoisted_58 = ["onClick"]
const _hoisted_59 = ["onClick"]
const _hoisted_60 = ["onClick"]
const _hoisted_61 = ["onClick"]
const _hoisted_62 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_ProviderForm = _resolveComponent("ProviderForm")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _component_UserNameLabel = _resolveComponent("UserNameLabel")!
  const _component_AccountWidget = _resolveComponent("AccountWidget")!
  const _component_Bar = _resolveComponent("Bar")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_BalanceCorrectionModal = _resolveComponent("BalanceCorrectionModal")!
  const _component_ProviderRequestsModal = _resolveComponent("ProviderRequestsModal")!
  const _component_ProviderInvoiceDiffModal = _resolveComponent("ProviderInvoiceDiffModal")!
  const _component_ProviderReportCheckModal = _resolveComponent("ProviderReportCheckModal")!
  const _component_SettingsHistoryModal = _resolveComponent("SettingsHistoryModal")!
  const _component_TraderRewardSettingsForm = _resolveComponent("TraderRewardSettingsForm")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!
  const _directive_bs_dropdown_fixed = _resolveDirective("bs-dropdown-fixed")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "loader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("ul", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Tabs, (value, tab) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: tab,
                          class: "nav-item nav-item-spaced d-lg-block text-nowrap"
                        }, [
                          _createElementVNode("a", {
                            href: "#",
                            onClick: _withModifiers(($event: any) => (_ctx.selectTab(value)), ["prevent"]),
                            class: _normalizeClass(["nav-link tab", {'active': _ctx.filters.activity === value}])
                          }, _toDisplayString(_ctx.helper.trans(`aggregators.tab.${value}`)), 11, _hoisted_9)
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control form-control-sm",
                      onKeydown: _cache[0] || (_cache[0] = _withKeys(
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)), ["enter"])),
                      placeholder: _ctx.helper.trans('labels.name'),
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.query) = $event))
                    }, null, 40, _hoisted_12), [
                      [_vModelText, _ctx.filters.query]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_Multiselect, {
                      id: "name",
                      class: "multiselect-sm",
                      modelValue: _ctx.filters.providerName,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.providerName) = $event)),
                      options: _ctx.providerConfigs.map((item) => item.name),
                      "custom-label": (opt) => `${opt}`,
                      multiple: false,
                      "select-label": "Select",
                      placeholder: _ctx.helper.trans('labels.type')
                    }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)), ["prevent"])),
                        class: "btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first"
                      }, _toDisplayString(_ctx.helper.trans('button.apply')), 1),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearFilters && _ctx.clearFilters(...args)), ["prevent"])),
                        class: "btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first"
                      }, _toDisplayString(_ctx.helper.trans('button.reset')), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showEditModal())),
                      class: "btn btn-sm btn-outline-primary text-nowrap text-capitalize"
                    }, _toDisplayString(_ctx.helper.trans('button.create')), 1)
                  ]),
                  _createVNode(_component_b_modal, {
                    title: _ctx.createModalTitle,
                    modelValue: _ctx.createModal,
                    "dialog-class": "modal-lg",
                    "body-class": "pt-0",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.createModal = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ProviderForm, { ref: "createForm" }, null, 512)
                    ]),
                    footer: _withCtx(() => [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.createModal = false)),
                        class: "btn btn-outline-secondary btn-sm text-capitalize-first"
                      }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1),
                      _createVNode(_component_LoaderWrapper, {
                        ref: "loaderCreateFrom",
                        zoom: 0.5
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("button", {
                            type: "button",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.save())),
                            class: "btn btn-outline-primary btn-sm text-capitalize-first"
                          }, _toDisplayString(_ctx.helper.trans('button.save')), 1)
                        ]),
                        _: 1
                      }, 512)
                    ]),
                    _: 1
                  }, 8, ["title", "modelValue"]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("table", _hoisted_24, [
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.providers, (provider) => {
                          return (_openBlock(), _createElementBlock("tr", null, [
                            _createElementVNode("td", _hoisted_25, _toDisplayString(provider.id), 1),
                            _createElementVNode("td", _hoisted_26, [
                              (provider._trader)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                    _withDirectives((_openBlock(), _createElementBlock("small", {
                                      class: "form-switch",
                                      title: `${_ctx.helper.trans('direction.in')}: ${_ctx.helper.trans(provider._trader.isActive ? 'trader.status.active' : 'trader.status.inactive')}`
                                    }, [
                                      _createElementVNode("input", {
                                        id: "traderStatus",
                                        disabled: _ctx.isTeamLead && !_ctx.store.getters.hasPermission(_ctx.UserPermission.MANAGE_TRADER_TRAFFIC),
                                        onClick: _withModifiers(($event: any) => (_ctx.toggleStatus(provider._trader, !provider._trader.isActive, _ctx.Direction.PAY_IN)), ["prevent"]),
                                        class: "form-check-input",
                                        style: {"cursor":"pointer"},
                                        type: "checkbox",
                                        role: "switch",
                                        checked: provider._trader.isActive
                                      }, null, 8, _hoisted_29)
                                    ], 8, _hoisted_28)), [
                                      [
                                        _directive_b_tooltip,
                                        void 0,
                                        void 0,
                                        {
                                          hover: true,
                                          left: true
                                        }
                                      ]
                                    ]),
                                    _withDirectives((_openBlock(), _createElementBlock("small", {
                                      class: "form-switch",
                                      title: `${_ctx.helper.trans('direction.out')}: ${_ctx.helper.trans(provider._trader.isPayOutActive ? 'trader.status.active' : 'trader.status.inactive')}`
                                    }, [
                                      _createElementVNode("input", {
                                        id: "traderStatus",
                                        disabled: _ctx.isTeamLead && !_ctx.store.getters.hasPermission(_ctx.UserPermission.MANAGE_TRADER_TRAFFIC),
                                        onClick: _withModifiers(($event: any) => (_ctx.toggleStatus(provider._trader, !provider._trader.isPayOutActive, _ctx.Direction.PAY_OUT)), ["prevent"]),
                                        class: "form-check-input",
                                        style: {"cursor":"pointer"},
                                        type: "checkbox",
                                        role: "switch",
                                        checked: provider._trader.isPayOutActive
                                      }, null, 8, _hoisted_31)
                                    ], 8, _hoisted_30)), [
                                      [
                                        _directive_b_tooltip,
                                        void 0,
                                        void 0,
                                        {
                                          hover: true,
                                          left: true
                                        }
                                      ]
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", _hoisted_32, [
                              (provider._trader)
                                ? (_openBlock(), _createBlock(_component_UserNameLabel, {
                                    key: 0,
                                    style: {"flex":"0.3"},
                                    user: provider._trader
                                  }, null, 8, ["user"]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", _hoisted_33, [
                              _createTextVNode(_toDisplayString(provider.sysname) + " ", 1),
                              _createElementVNode("span", _hoisted_34, _toDisplayString(provider.name), 1),
                              (provider.webhookAuth?.isWarning)
                                ? _withDirectives((_openBlock(), _createElementBlock("i", {
                                    key: 0,
                                    class: "fa fa-exclamation-triangle text-danger ms-1",
                                    title: `${_ctx.helper.trans('labels.webhook_auth')}: ${_ctx.helper.trans(`webhook_auth.${provider.webhookAuth.level}`)}. ${provider.webhookAuth.note}`
                                  }, null, 8, _hoisted_35)), [
                                    [
                                      _directive_b_tooltip,
                                      void 0,
                                      void 0,
                                      {
                                        hover: true,
                                        right: true
                                      }
                                    ]
                                  ])
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(provider._traderAccounts, (account) => {
                                return (_openBlock(), _createElementBlock("div", null, [
                                  _createElementVNode("div", _hoisted_36, [
                                    _createElementVNode("div", _hoisted_37, [
                                      _createVNode(_component_AccountWidget, {
                                        "show-id": true,
                                        account: account
                                      }, null, 8, ["account"])
                                    ])
                                  ])
                                ]))
                              }), 256))
                            ]),
                            _createElementVNode("td", null, [
                              (provider.balance)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(_ctx.numberFormatter.formatMoney(provider.balance)), 1))
                                : _createCommentVNode("", true),
                              (provider.balanceUpdatedAt)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                    _createElementVNode("small", _hoisted_40, _toDisplayString(_ctx.dateHelper.format(provider.balanceUpdatedAt)), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", _hoisted_41, [
                              (provider.currency)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(provider.currency), 1))
                                : _createCommentVNode("", true),
                              (provider.minPayInSum)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(_ctx.helper.trans('labels.from_limit', {sum: _ctx.numberFormatter.formatMoney(provider.minPayInSum), currency: ''})), 1))
                                : _createCommentVNode("", true),
                              (provider.maxPayInSum)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(_ctx.helper.trans('labels.to_limit', {sum: _ctx.numberFormatter.formatMoney(provider.maxPayInSum), currency: ''})), 1))
                                : _createCommentVNode("", true),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(provider.allowedPaymentOptions, (option) => {
                                return (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(_ctx.helper.trans('payment_options.' + option)), 1))
                              }), 256)),
                              (provider.defaultPaymentOption)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(_ctx.helper.trans('labels.default')) + ": " + _toDisplayString(_ctx.helper.trans('payment_options.' + provider.defaultPaymentOption)), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", _hoisted_47, [
                              (_ctx.countStatsData[provider.id])
                                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                    _createVNode(_component_Bar, {
                                      "chart-options": _ctx.countChartOptions,
                                      "chart-data": _ctx.countStatsData[provider.id]
                                    }, null, 8, ["chart-options", "chart-data"])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", _hoisted_49, [
                              (_ctx.isAdmin)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      onClick: ($event: any) => (_ctx.showEditModal(provider)),
                                      class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize"
                                    }, [
                                      _cache[15] || (_cache[15] = _createElementVNode("i", { class: "fa fa-pencil" }, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.edit')), 1)
                                    ], 8, _hoisted_51),
                                    _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_52, _cache[16] || (_cache[16] = [
                                      _createElementVNode("span", { class: "visually-hidden" }, "Toggle Dropdown", -1)
                                    ]))), [
                                      [_directive_bs_dropdown_fixed]
                                    ]),
                                    _createElementVNode("ul", _hoisted_53, [
                                      (_ctx.isAdmin && _ctx.store.getters.hasPermission(_ctx.UserPermission.BALANCE_CORRECTION))
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_54, [
                                            _createElementVNode("a", {
                                              class: "dropdown-item",
                                              href: "#",
                                              onClick: _withModifiers(($event: any) => (_ctx.openBalanceCorrection(provider)), ["prevent"])
                                            }, [
                                              _cache[17] || (_cache[17] = _createElementVNode("i", { class: "fa fa-calculator" }, null, -1)),
                                              _createTextVNode(" " + _toDisplayString(_ctx.$t('button.balance_correction')), 1)
                                            ], 8, _hoisted_55)
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("li", null, [
                                        _createElementVNode("a", {
                                          class: "dropdown-item",
                                          href: "#",
                                          onClick: _withModifiers(($event: any) => (_ctx.$refs.providerRequestsModal.show(provider.id)), ["prevent"])
                                        }, [
                                          _cache[18] || (_cache[18] = _createElementVNode("i", { class: "fa-regular fa-comments" }, null, -1)),
                                          _createTextVNode(" " + _toDisplayString(_ctx.$t('labels.provider_request_log')), 1)
                                        ], 8, _hoisted_56)
                                      ]),
                                      (_ctx.isAdmin)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_57, [
                                            _createElementVNode("a", {
                                              class: "dropdown-item",
                                              href: "#",
                                              onClick: _withModifiers(($event: any) => (_ctx.showProviderHistory(provider)), ["prevent"])
                                            }, [
                                              _cache[19] || (_cache[19] = _createElementVNode("i", { class: "fa fa-clock-rotate-left" }, null, -1)),
                                              _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('labels.history')), 1)
                                            ], 8, _hoisted_58)
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("li", null, [
                                        _createElementVNode("a", {
                                          class: "dropdown-item",
                                          href: "#",
                                          onClick: _withModifiers(($event: any) => (_ctx.$refs.providerInvoiceDiffModal.show(provider)), ["prevent"])
                                        }, [
                                          _cache[20] || (_cache[20] = _createElementVNode("i", { class: "fa-regular fa-file-text" }, null, -1)),
                                          _createTextVNode(" " + _toDisplayString(_ctx.$t('labels.provider_invoice_diff')), 1)
                                        ], 8, _hoisted_59)
                                      ]),
                                      _createElementVNode("li", null, [
                                        _createElementVNode("a", {
                                          class: "dropdown-item",
                                          href: "#",
                                          onClick: _withModifiers(($event: any) => (_ctx.$refs.providerReportCheckModal.show(provider)), ["prevent"])
                                        }, [
                                          _cache[21] || (_cache[21] = _createElementVNode("i", { class: "fa-regular fa-file-text" }, null, -1)),
                                          _createTextVNode(" " + _toDisplayString(_ctx.$t('labels.provider_upload_report')), 1)
                                        ], 8, _hoisted_60)
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.isOperator)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    type: "button",
                                    onClick: _withModifiers(($event: any) => (_ctx.showProviderHistory(provider)), ["prevent"]),
                                    class: "ms-2 btn btn-sm btn-outline-secondary text-nowrap text-capitalize"
                                  }, [
                                    _cache[22] || (_cache[22] = _createElementVNode("i", { class: "fa fa-clock-rotate-left" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('labels.history')), 1)
                                  ], 8, _hoisted_61))
                                : _createCommentVNode("", true),
                              ((_ctx.isAdmin) || (_ctx.isOperator && !_ctx.store.getters.hasPermission(_ctx.UserPermission.HIDE_DEAL_RATES)))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 2,
                                    type: "button",
                                    onClick: ($event: any) => (_ctx.showRouting(provider._trader)),
                                    class: "ms-2 btn btn-sm btn-outline-dark text-nowrap text-capitalize"
                                  }, [
                                    _cache[23] || (_cache[23] = _createElementVNode("i", { class: "fa fa-percent" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('labels.percent_rates')), 1)
                                  ], 8, _hoisted_62))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 256))
                      ])
                    ]),
                    (_ctx.response.totalCount > _ctx.response.items.length)
                      ? (_openBlock(), _createBlock(_component_b_pagination, {
                          key: 0,
                          modelValue: _ctx.page,
                          "onUpdate:modelValue": [
                            _cache[9] || (_cache[9] = ($event: any) => ((_ctx.page) = $event)),
                            _cache[10] || (_cache[10] = ($event: any) => (_ctx.loadList()))
                          ],
                          "total-rows": _ctx.response.totalCount,
                          "per-page": _ctx.response.limit,
                          limit: 20,
                          "prev-text": _ctx.$t('button.back'),
                          "next-text": _ctx.$t('button.next'),
                          align: "start",
                          "first-number": "",
                          "hide-goto-end-buttons": "",
                          "hide-ellipsis": ""
                        }, null, 8, ["modelValue", "total-rows", "per-page", "prev-text", "next-text"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_BalanceCorrectionModal, {
        showModal: _ctx.balanceCorrectionModal,
        accountId: _ctx.selectedProvider?._traderAccounts?.[0]?.id,
        providerName: _ctx.selectedProvider?.name,
        "onUpdate:showModal": _cache[11] || (_cache[11] = ($event: any) => (_ctx.balanceCorrectionModal = $event)),
        onSuccess: _ctx.loadList
      }, null, 8, ["showModal", "accountId", "providerName", "onSuccess"]),
      _createVNode(_component_ProviderRequestsModal, { ref: "providerRequestsModal" }, null, 512),
      _createVNode(_component_ProviderInvoiceDiffModal, { ref: "providerInvoiceDiffModal" }, null, 512),
      _createVNode(_component_ProviderReportCheckModal, { ref: "providerReportCheckModal" }, null, 512),
      _createVNode(_component_SettingsHistoryModal, {
        ref: "providerHistoryModal",
        "entity-type": "provider"
      }, null, 512),
      _createVNode(_component_b_modal, {
        "dialog-class": "modal-xxl",
        title: `${_ctx.routingTrader?.name}`,
        modelValue: _ctx.routingTrader !== null,
        "body-class": "pt-0",
        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ($event === false && (_ctx.routingTrader = null)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_TraderRewardSettingsForm, {
            ref: "traderRewardSettingsForm",
            trader: _ctx.routingTrader
          }, null, 8, ["trader"])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.routingTrader = null)),
            class: "btn btn-outline-secondary btn-sm text-capitalize-first"
          }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1),
          (_ctx.isAdmin || _ctx.isOperator)
            ? (_openBlock(), _createBlock(_component_LoaderWrapper, {
                key: 0,
                ref: "loaderRoutingRule",
                zoom: 0.5
              }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.saveRoutingRule())),
                    class: "btn btn-outline-primary btn-sm text-capitalize-first"
                  }, _toDisplayString(_ctx.helper.trans('button.save')), 1)
                ]),
                _: 1
              }, 512))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["title", "modelValue"])
    ]),
    _: 1
  }, 512))
}